<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="productsettings_new" ttGoto="productsetting" [ttGotoParms]="{ productsetting_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListProductSettings"></tt-list>
</tt-page>
